<template>
    <b-card id="metodo-de-pago" :header="header">
        <metodos-pago-stripe v-model="form.selectedPM" allow-select />
    </b-card>
</template>

<script>
import MetodosPagoStripe from '../../usuario-cuenta/metodos-pago-stripe'
import contrataYa from './contrataYa'

export default {
    name: 'metodoDePago',
    components: {
        MetodosPagoStripe
    },
    props: {
        header: {
            type: String,
            default: 'Agregar método de pago'
        }
    },
    data() {
        return {
            form: contrataYa.workingData,
        }
    }
}
</script>